module.exports = __webpack_public_path__ + "img/logo-bar.01a9b143.png";